import { Component } from 'react';
import { connect } from 'react-redux';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = state => ({
  location: state.router.location,
});

export default connect(mapStateToProps)(ScrollToTop);
